import { API } from "@/lib/api";
import { APIService, FetchListRequest } from "@/services/api";
import { FilterType } from "@/lib/filters";
import { WriteInvoiceSpecificationForm } from "@/schemas/invoiceSpecificationForm";
import {
  ReadInvoiceSpecification,
  UpdateInvoiceSpecification,
} from "@/types/invoiceSpecification";

const InvoiceSpecificationsAPIService =
  new APIService<ReadInvoiceSpecification>(API.InvoiceSpecifications);

export const getInvoiceSpecificationsListGetter =
  (settlementId: string) =>
  (fetchParams: FetchListRequest<ReadInvoiceSpecification>) =>
    InvoiceSpecificationsAPIService.getList({
      ...fetchParams,
      filters: [
        ...(fetchParams.filters ?? []),
        {
          id: "period_id",
          value: {
            value: settlementId,
            filter: FilterType.EqualsString,
          },
        },
      ],
      queryParams: {
        ...fetchParams.queryParams,
        include_deleted: "true",
      },
    });

export const invoiceSpecificationsService = {
  getList: (fetchParams: FetchListRequest<ReadInvoiceSpecification>) =>
    InvoiceSpecificationsAPIService.getList({
      ...fetchParams,
      queryParams: {
        ...fetchParams.queryParams,
        include_deleted: "true",
      },
    }),
  getInvoiceSpecification: (invoiceSpecificationId: string) =>
    InvoiceSpecificationsAPIService.get(invoiceSpecificationId),
  patchBasicData: (
    invoiceSpecificationId: string,
    item: UpdateInvoiceSpecification,
  ) => InvoiceSpecificationsAPIService.patch(invoiceSpecificationId, item),
  postSpecification: (item: WriteInvoiceSpecificationForm) =>
    InvoiceSpecificationsAPIService.post(item),
  delete: (invoiceSpecificationId: string) =>
    InvoiceSpecificationsAPIService.delete(invoiceSpecificationId),
};
